export default "__VITE_ASSET__D7jlpaqG__"